// src/pages/LoginPage.jsx
import React, { useState } from "react";

const GoogleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 48 48" style={{ flexShrink: 0 }}>
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
  </svg>
);

export default function LoginPage({ onLogin }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async () => {
    setLoading(true);
    setError("");
    try {
      await onLogin();
    } catch (err) {
      setError("Sign-in failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "linear-gradient(135deg, #0d2410 0%, #1a3a1e 40%, #2d7a3a 100%)",
      padding: 16,
    }}>
      {/* Background pattern */}
      <div style={{
        position: "fixed", inset: 0, opacity: 0.05,
        backgroundImage: "radial-gradient(circle, #fff 1px, transparent 1px)",
        backgroundSize: "30px 30px", pointerEvents: "none",
      }} />

      <div style={{
        background: "#fff", borderRadius: 20, padding: "48px 40px", width: "100%", maxWidth: 400,
        textAlign: "center", boxShadow: "0 32px 80px rgba(0,0,0,0.3)", position: "relative",
      }}>
        {/* Logo */}
        <div style={{
          width: 72, height: 72, background: "linear-gradient(135deg, #e8f5e9, #c8e6c9)",
          borderRadius: 20, display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 36, margin: "0 auto 20px", border: "2px solid #b2d8b7",
        }}>
          🌾
        </div>

        <h1 style={{ fontSize: 26, fontWeight: 900, color: "#1a1a1a", margin: "0 0 6px", letterSpacing: -0.5 }}>
          AgriPragati CMS
        </h1>
        <p style={{ color: "#777", fontSize: 14, margin: "0 0 36px", lineHeight: 1.5 }}>
          Content Management System<br />for AgriPragati Platform
        </p>

        {error && (
          <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8,
            padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#c53030" }}>
            {error}
          </div>
        )}

        <button
          onClick={handleLogin}
          disabled={loading}
          style={{
            width: "100%", padding: "14px 0", borderRadius: 12, border: "1px solid #e0e0e0",
            background: loading ? "#f9f9f9" : "#fff", fontSize: 15, fontWeight: 600,
            cursor: loading ? "not-allowed" : "pointer", display: "flex", alignItems: "center",
            justifyContent: "center", gap: 12, fontFamily: "inherit",
            boxShadow: "0 1px 4px rgba(0,0,0,0.08)", transition: "all 0.2s",
            color: "#333",
          }}
          onMouseEnter={e => !loading && (e.currentTarget.style.boxShadow = "0 3px 12px rgba(0,0,0,0.15)")}
          onMouseLeave={e => (e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.08)")}
        >
          <GoogleIcon />
          {loading ? "Signing in..." : "Continue with Google"}
        </button>

        <div style={{ marginTop: 32, padding: "16px", background: "#f8fdf8", borderRadius: 10, border: "1px solid #d4ebd6" }}>
          <p style={{ fontSize: 12, color: "#555", lineHeight: 1.6, margin: 0 }}>
            <strong style={{ color: "#2d7a3a" }}>First time?</strong> Your account is created automatically.<br />
            To get <strong>Admin</strong> access, ask an existing admin to update your role in:<br />
            <code style={{ background: "#e8f5e9", padding: "1px 5px", borderRadius: 4, fontSize: 11 }}>
              Firebase Console → Firestore → users → your UID → role: "admin"
            </code>
          </p>
        </div>
      </div>
    </div>
  );
}
